import { Box, Button, CardMedia, IconButton, Input, Step, StepLabel, Stepper, Tab, Tabs, TextField, Typography } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

import Step1 from "../../components/delete-store-steps/step1";
import Step2 from "../../components/delete-store-steps/step2";
import Step3 from "../../components/delete-store-steps/step3";
import Step4 from "../../components/delete-store-steps/step4";
import Step5 from "../../components/delete-store-steps/step5";
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import OtpVerification2 from "../../Modals/optVerification";
import VerifiedIcon from '@mui/icons-material/Verified';
import CloseIcon from "@mui/icons-material/Close";
import AIStyles from "../../Modals/AIstyles";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Settings: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [openAIModal, setOpenAIModal] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5"];
  const navigate = useNavigate();

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setIsOtpVerified(false);
  };

  const handleOpenOtp = () => {
    setOpenOtpModal(true);
  };
  const handleOpenAI = () => {
    setOpenAIModal(true);
  };

  const handleOtpVerified = () => {
    setOpenOtpModal(false);
    setIsOtpVerified(true);
  };
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [alertMessage, setAlertMessage] = useState("");

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <Step1 />;
      case 1:
        return <Step2 />;
      case 2:
        return <Step3 />;
      case 3:
        return <Step4 />;
      case 4:
        return <Step5 />;
      default:
        return <Typography>Unknown Step</Typography>;
    }
  };

  return (
    <>
      <div className="main_title">
        <h1>Settings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Settings
        </p>
      </div>

      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        {/* <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
        
          <Tab label="Store Closure" {...a11yProps(0)} />
        </Tabs> */}
      </Box>
    
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards">
          <section className="wrap_viewDemo_steps uh_spc">
            <div className="container">
              <div className="page_head">
                <p>
                  <strong>Close or Pause My Store</strong>
                </p>
              </div>

              <div className="steps_grid">
                <div className="step_lt">
                  <Stepper activeStep={activeStep} orientation="horizontal">
                    {steps.map((label, index) => (
                      <Step key={index}>
                        <StepLabel></StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </div>

                <div className="step_rt">
                  <div className="shadow_box shadow_box1">
                    {activeStep === steps.length ? (
                      <div className="completed_step">
                        <Typography>All steps completed - you're finished!</Typography>
                        <Button onClick={handleReset} sx={{ mt: 2 }}>
                          Reset
                        </Button>
                      </div>
                    ) : (
                      <>
                        {renderStepContent(activeStep)}

                        <div className="btn_flex">
                          <Button
                            className="btn btn_grey"
                            onClick={handleBack}
                            disabled={activeStep === 0}
                          >
                            Back
                          </Button>

                          {/* ✅ Last Step: Conditional Buttons */}
                          {activeStep === steps.length - 1 ? (
                            isOtpVerified ? (
                              <Button className="btn btn_primary">
                                <DoNotDisturbAltIcon /> Submit Closure Request
                              </Button>
                            ) : (
                              <Button
                                className="btn btn_primary"
                                onClick={handleOpenOtp}
                              >
                                <VerifiedIcon /> Verify Email
                              </Button>
                            )
                          ) : (
                            <Button
                              className="btn btn_primary"
                              onClick={handleNext}
                            >
                              Next
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </CustomTabPanel>

      {/* ✅ OTP Modal */}
      <OtpVerification2
        open={openOtpModal}
        onClose={() => setOpenOtpModal(false)}
        setOpen={setOpenOtpModal}
        onVerify={handleOtpVerified} // when verified, sets isOtpVerified = true
      />
      <AIStyles
        open={openAIModal}
        onClose={() => setOpenAIModal(false)}
        setOpen={setOpenAIModal}
      />
    </>
  );
};

export default Settings;
